import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  IPartner,
  IPartnerListResult,
  IPartnerPaginationResult,
  IPartnerArtist,
  IPartnerArtistPaginationResult,
  IPartnerAdmin,
  IPartnerAdminPaginationResult,
  IPartnerInvitation,
  IPartnerInvitationListResult,
  IPartnerInvitationPaginationResult,
} from '../interfaces/Partner.js';
import { Artist } from './Artist.js';
import { PaginationResult, ListResult } from './List.js';

/**
 * Partner
 */
class Partner extends ABaseModel implements IPartner {
  id: number;
  type: string;
  status: number;
  name: string;
  email: string;
  phone: string;
  rank: number;
  website: string;
  description: string;
  city: string;
  postCode: string;
  addressLine1: string;
  addressLine2: string;
  county: string;
  countryCode: string;
  openingHours: string;
  canAdminArtist: boolean;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerListResult
 */
class PartnerListResult extends ListResult implements IPartnerListResult {
  declare items: Array<Partner>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerPaginationResult
 */
class PartnerPaginationResult extends PaginationResult implements IPartnerPaginationResult {
  declare items: Array<Partner>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerArtist
 */
class PartnerArtist extends ABaseModel implements IPartnerArtist {
  artistId: number;
  partnerId: number;
  status: number;
  admin: boolean;
  rank: number;
  canUpdate: boolean;
  canManageArtwork: boolean;
  artist: Artist;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerArtistPaginationResult
 */
class PartnerArtistPaginationResult extends PaginationResult implements IPartnerArtistPaginationResult {
  declare items: Array<PartnerArtist>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerAdmin
 */
class PartnerAdmin extends ABaseModel implements IPartnerAdmin {
  userId: number;
  partnerId: number;
  status: number;
  aclRole: string;
  userStatus: number;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userRole: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerAdminPaginationResult
 */
class PartnerAdminPaginationResult extends PaginationResult implements IPartnerAdminPaginationResult {
  declare items: Array<PartnerAdmin>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerInvitation
 */
class PartnerInvitation extends ABaseModel implements IPartnerInvitation {
  id: number;
  created: string;
  expired: boolean;
  expirationDate: string;
  email: string;
  aclRole: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerInvitationListResult
 */
class PartnerInvitationListResult extends ListResult implements IPartnerInvitationListResult {
  declare items: Array<PartnerInvitation>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * PartnerInvitationPaginationResult
 */
class PartnerInvitationPaginationResult extends PaginationResult implements IPartnerInvitationPaginationResult {
  declare items: Array<PartnerInvitation>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export {
  Partner,
  PartnerPaginationResult,
  PartnerListResult,
  PartnerArtist,
  PartnerArtistPaginationResult,
  PartnerAdmin,
  PartnerAdminPaginationResult,
  PartnerInvitation,
  PartnerInvitationListResult,
  PartnerInvitationPaginationResult,
};
